import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { HeroBanner } from '../components/HeroBanner';
import { WelcomeSection } from '../components/WelcomeSection';
import { ShopByVehicle } from '../components/ShopByVehicle';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { CategoryBanners } from '../components/CategoryBanners';
import { TrustBadges } from '../components/TrustBadges';
import { Testimonials } from '../components/Testimonials';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
interface HomePageProps {
  onNavigate: (page: 'home' | 'archive' | 'detail' | 'configurator', productId?: number) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  // Listen for custom navigation events from HeroBanner
  useEffect(() => {
    const handleCustomNav = (e: CustomEvent) => {
      onNavigate(e.detail);
    };
    window.addEventListener('navigate', handleCustomNav as EventListener);
    return () => window.removeEventListener('navigate', handleCustomNav as EventListener);
  }, [onNavigate]);
  return <div className="min-h-screen flex flex-col bg-background font-sans" data-id="element-452">
      <Header data-id="element-453" />
      <Navigation onNavigate={onNavigate} data-id="element-454" />
      <main className="flex-grow" data-id="element-455">
        <HeroBanner data-id="element-456" />
        <WelcomeSection data-id="element-457" />
        <ShopByVehicle data-id="element-458" />
        <FeaturedProducts onNavigate={onNavigate} data-id="element-459" />
        <CategoryBanners data-id="element-460" />
        <TrustBadges data-id="element-461" />
        <Testimonials data-id="element-462" />
        <Newsletter data-id="element-463" />
      </main>
      <Footer data-id="element-464" />
    </div>;
}